import {EquipmentSimple} from './EquipmentSimple'

export class EquipmentForParent extends EquipmentSimple {

    static from(json: any): EquipmentForParent {
        return new EquipmentForParent(
            Number(json.id),
            json.condominiumCd,
            json.name,
            json.reservationCountDaily,
            json.reservationCountMonthly,
            json.lotteryEntryCountMonthly,
        )
    }
}
